import { render, staticRenderFns } from "./ModalEnvio.vue?vue&type=template&id=144e4dd3&scoped=true"
import script from "./ModalEnvio.vue?vue&type=script&lang=js"
export * from "./ModalEnvio.vue?vue&type=script&lang=js"
import style0 from "./ModalEnvio.vue?vue&type=style&index=0&id=144e4dd3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144e4dd3",
  null
  
)

export default component.exports